module.exports = __webpack_public_path__ + "img/展开.cbbbf623.svg";